"use client"

import LinkWithParams from "@/lib/common/LinkWithParams"
import { Desktop, Mobile } from "@/lib/common/MediaQueries"
import styled from "@emotion/styled"
import { Breadcrumbs, Typography } from "@mui/material"
import BreadCrumbIcon from "./icons/BreadCrumbsIcon"

const StyledContainer = styled.div`
  padding: 16px 0;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 24px 0;
  }
`

type BreadcrumbType = { title: string | JSX.Element; url: string }

type Props = {
  current: BreadcrumbType
  parents: BreadcrumbType[]
}

const CustomBreadcrumbs: React.FC<Props> = ({ current, parents }) => {
  return (
    <StyledContainer>
      <Breadcrumbs separator={<BreadCrumbIcon />} aria-label="מיקומך בדפי האתר">
        {parents.map((item, index) => (
          <LinkWithParams
            key={index}
            style={{
              textDecoration: "none",
            }}
            href={item.url}
          >
            <Desktop>
              <Typography variant="body2" color={"#6F6F6F"}>
                {item.title}
              </Typography>
            </Desktop>
            <Mobile>
              <Typography variant="body3" color={"#6F6F6F"}>
                {item.title}
              </Typography>
            </Mobile>
          </LinkWithParams>
        ))}
        <div>
          <Desktop>
            <Typography variant="body2">{current.title}</Typography>
          </Desktop>
          <Mobile>
            <Typography variant="body3">{current.title}</Typography>
          </Mobile>
        </div>
      </Breadcrumbs>
    </StyledContainer>
  )
}

export default CustomBreadcrumbs
